import { render, staticRenderFns } from "./campaignRulesModal.vue?vue&type=template&id=51e343b2&"
import script from "./campaignRulesModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./campaignRulesModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports